import styled from "styled-components";

export const Label = styled.label`
  display: inline-block;
  color: var(--text-primary);
  font-size: 14px;
  font-weight: 500;
  margin: 8px 0;
`;
